import Form from "../Form/Form";
import { useSelector } from "react-redux";


const CreateRace=()=>{
    const { lenguage } = useSelector((s) => s);
    return(
        <>
        <br />
        <h1>{lenguage?"CREATE BREED":"CREA UNA RAZA"}</h1>
        <Form/>
        </>
    )
}

export default CreateRace;
